import type { FunctionComponent, SVGProps } from "react"
import type { ZodiacSign } from "../types"

import Aquarius from "@/assets/svg/lpr4/zodiac/Aquarius.svg?react"
import Aries from "@/assets/svg/lpr4/zodiac/Aries.svg?react"
import Cancer from "@/assets/svg/lpr4/zodiac/Cancer.svg?react"
import Capricorn from "@/assets/svg/lpr4/zodiac/Capricorn.svg?react"
import Gemini from "@/assets/svg/lpr4/zodiac/Gemini.svg?react"
import Leo from "@/assets/svg/lpr4/zodiac/Leo.svg?react"
import Libra from "@/assets/svg/lpr4/zodiac/Libra.svg?react"
import Pisces from "@/assets/svg/lpr4/zodiac/Pisces.svg?react"
import Sagittarius from "@/assets/svg/lpr4/zodiac/Sagittarius.svg?react"
import Scorpio from "@/assets/svg/lpr4/zodiac/Scorpio.svg?react"
import Taurus from "@/assets/svg/lpr4/zodiac/Taurus.svg?react"
import Virgo from "@/assets/svg/lpr4/zodiac/Virgo.svg?react"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

export const zodiacIcons: Record<ZodiacSign, SvgComponent> = {
  Aquarius,
  Aries,
  Cancer,
  Capricorn,
  Gemini,
  Leo,
  Libra,
  Pisces,
  Sagittarius,
  Scorpio,
  Taurus,
  Virgo,
}
